export interface PlayerOutputApiModel {
    [x: string]: any;

}

export class PlayerOutputApiModel {
    constructor(init?: PlayerOutputApiModel) {
        Object.assign(this, init);
    }
}